import React from 'react';

import { ExternalPatient, PatientProps, usePatientContext } from '../../../../contexts/PatientContext';
import { Page, useExecutiveCheckupRouter } from '../../router/context';

import SystemUnavailable from '../../../../components/SystemUnavailable';
import { LoadingOverlay } from '../../../../components';

import { PatientFormTemplate } from '../../../../templates/PatientFormTemplate';
import ModalNoEligibility from '../../components/ModalNoEligibility';

import { useMainRouter } from '../../../../Router/pageComponents';
import { useServiceContext } from '../../../../contexts/ServiceContext';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import { ScheduleItemPropsBuilder } from '../../../../models/Schedule';
import { ScheduleChannelsMapped } from '../../../../utils/enums/channels';
import { UnitAppointment } from '../../../../models/UnitSchedule';
import { useModuleContext } from '../../../../contexts/ModuleContext';
import { usePatientExternal } from '../../../../store/patientExternal';

export function PatientFormPage() {
  const { patientSelected, setPatientSelected } = usePatientContext();
  const { patient: externalPatient } = usePatientExternal();

  const router = useExecutiveCheckupRouter();
  const { setSelectedItem: setSchedule } = useScheduleContext();
  const { selectedService: service } = useServiceContext();
  const { setLogged } = useModuleContext();

  const [loading, setLoading] = React.useState(false);
  const [isModalNoEligibility, setIsModalNoEligibility] = React.useState(false);
  const [isModalSystemUnavailableVisible, setIsModalSystemUnavailableVisible] = React.useState(false);

  const handlePatient = async (props: { patient?: PatientProps; externalPatient?: ExternalPatient }) => {
    setLoading(true);

    if (props.patient) setPatientSelected(props.patient);

    const schedule = ScheduleItemPropsBuilder();
    schedule.setPatientName(props.patient?.name || props.externalPatient?.name || '');

    const product = service.products?.[0];

    if (product) {
      schedule.setScheduleType({ careType: 'TELEMEDICINE' });
      schedule.setPayment({ type: 'PARTICULAR' });
      schedule.setProduct(product);

      const coverage = product.coverages?.[0];

      if (coverage) {
        setSchedule({
          ...schedule.build(),
          catalogItemId: coverage.id,
          productId: product.id,
          itemId: ScheduleChannelsMapped.TELEORIENTATION,
          unit: {} as UnitAppointment,
          unitId: ScheduleChannelsMapped.TELEORIENTATION
        });
      }
    }

    router.navigate(Page.PRODUCT_SLOTS);

    setLoading(false);
  };

  const { goBack: mainRouterGoBack } = useMainRouter();

  function handleGoBack() {
    if (router.history.length === 1) return mainRouterGoBack();
    else router.goBack();
  }

  React.useEffect(() => {
    if (patientSelected) {
      handlePatient({ patient: patientSelected });
      setLogged(true);
    }

    if (externalPatient) {
      handlePatient({ externalPatient });
      setLogged(true);
    }
  }, []);

  if (patientSelected || externalPatient) return <LoadingOverlay loading withBackground />;

  return (
    <>
      <PatientFormTemplate
        patient={patientSelected}
        handlePatientSubmit={patient => handlePatient({ patient })}
        goBack={handleGoBack}
      />

      <SystemUnavailable
        visible={isModalSystemUnavailableVisible}
        onClose={() => setIsModalSystemUnavailableVisible(false)}
      />

      <ModalNoEligibility visible={isModalNoEligibility} onClose={() => setIsModalNoEligibility(false)} />

      <LoadingOverlay loading={loading} />
    </>
  );
}
